module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('hr', {
    staticClass: "hr2"
  })]), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART 1")])])]), _vm._v(" "), _c('hr', {
    staticClass: "hr2c"
  }), _vm._v(" "), _c('p', {
    staticClass: "tocp1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_vm._v("LEARNING TO EMBRACE THE POWER OF YOUR ENERGY")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#ch01"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 1:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Awakening to Yourself As an Energetic Being")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 2:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Power of Energy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toccb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 3:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Miraculous Energy of Self-Love")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART 2")])])]), _vm._v(" "), _c('hr', {
    staticClass: "hr2c"
  }), _vm._v(" "), _c('p', {
    staticClass: "tocp1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WORKING WITH THE ENERGY OF THE UNIVERSE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 4:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Your Creative Powers")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 5:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Discover Your Purpose")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 6:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Let the Universe Guide You")])])]), _vm._v(" "), _c('p', {
    staticClass: "toccb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 7:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Access Your Intuition")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART 3")])])]), _vm._v(" "), _c('hr', {
    staticClass: "hr2c"
  }), _vm._v(" "), _c('p', {
    staticClass: "tocp1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MANIFESTING A POSITIVE LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 8:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Overcome Common Obstacles")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 9:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Embrace Higher Realms")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 10:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Heal Your Mind, Body, and Soul")])])]), _vm._v(" "), _c('p', {
    staticClass: "toccb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 11:")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Positive Energy, Positive Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/final",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("FINAL THOUGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee67910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 66
// module chunks = 0